export const handleRole = (role) => {
  if (role === "superAdmin") {
    return "admin";
  }
  if (role === "operator" || role === "admin" || role === "user" || role === "agent" || role === "shipper") {
    return role;
  }
  return "user";
};